import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const EventInfo = forwardRef(({ eventId,eventTitle }, ref) => {
  const [eventName, setEventName] = useState(eventTitle || ''); // Prefill with eventTitle
  const [organizerEmail, setOrganizerEmail] = useState('');

  // On mount, populate organizerEmail from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user.email) {
          setOrganizerEmail(user.email);
        }
      } catch (e) {
        console.error('Invalid user data in localStorage:', e);
      }
    }
  }, []);

  useImperativeHandle(ref, () => ({
    getState: () => ({
      eventName,
      organizerEmail,
    }),
  }));

  return (
    <div>
      <div className="mb-3">
        <label className="form-label">Event Name</label>
        <input
          type="text"
          className="form-control"
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Organizer Email</label>
        <input
          type="email"
          className="form-control"
          value={organizerEmail}
          onChange={(e) => setOrganizerEmail(e.target.value)}
        />
      </div>
    </div>
  );
});

export default EventInfo;
